import { RowDataMember } from "../../components/MemberPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the MemberTable factory
 */
class MemberRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/accounts/get-range"
        this.accessData = "users"
    }

    create(user: any): RowDataMember {
        const rowDataMember: RowDataMember = {
            name: user.fullname,
            email: user.email,
            nric: user.nric,
            nric_fullname: user.nric_fullname,
            contactNo: user.phone_number,
            profilePicture: user.profilePicture,
            expoPushToken: user.expoPushToken,
            referral: user.referral,
            tempCode: user.tempCode,
            tempCodeTime: user.tempCodeTime,
            membershipType: user.membershipType,
            isDealer: user.isDealer,
            company: user.company,
            coins: user.coins,
            cash: user.cash,
            daily: user.daily,
            action: "",
            uid: user.uid,
            dob: user.dob,
            isVerified: user.isVerified,
            isFastPass: user.isFastPass,
            createdAt: user.createdAt,
            isCorporate: user.isCorporate,
            deleted: user.deleted,
        };
        return rowDataMember;
    }

    generateParams(params: any, extra: any): any {
        params["uid"] = extra.uid
        params["current"] = extra.current
        return params
    }
}

let memberRow: MemberRow | null = null;

export default function getMemberRow(): MemberRow {
    if (memberRow === null)
        memberRow = new MemberRow()
    return memberRow
}